import React, {Suspense, useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import {Route, Switch, useRouteMatch} from "react-router-dom";
import DataVendorStream from "../../pages/admin/data_vendors/DataVendorStream";
import DataVendorExtract from "../../pages/admin/data_vendors/DataVendorExtract";
import DataVendorAudience from "../../pages/admin/data_vendors/DataVendorAudience";
import DataVendorsList from "../../pages/admin/data_vendors/DataVendorsList";
import DataVendorsEdit from "../../pages/admin/data_vendors/DataVendorsEdit";
import DataVendorsNew from "../../pages/admin/data_vendors/DataVendorsNew";
import DataVendor from "../../pages/admin/data_vendors/DataVendor";
import NewDataVendorStream from "../../pages/admin/data_vendors/NewDataVendorStream";
import EditDataVendorStream from "../../pages/admin/data_vendors/EditDataVendorStream";
import NewDataVendorExtract from "../../pages/admin/data_vendors/NewDataVendorExtract";
import EditDataVendorExtract from "../../pages/admin/data_vendors/EditDataVendorExtract";
import DataVendorUser from '../../pages/admin/data_vendors/DataVendorUser';
import DataVendorUserEdit from '../../pages/admin/data_vendors/DataVendorUserEdit';
import DataVendorUserNew from '../../pages/admin/data_vendors/DataVendorUserNew';
import NewDataVendorAudience from "../../pages/admin/data_vendors/NewDataVendorAudience";
import EditDataVendorAudience from "../../pages/admin/data_vendors/EditDataVendorAudience";
import DataVendorInvoice from '../../pages/admin/data_vendors/DataVendorInvoice';

function DataVendors(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={`${path}`} component={DataVendorsList}/>
        <Route path={`${path}/new`} component={DataVendorsNew}/>
        <Route path={`${path}/:dataVendorKey/streams/new`} component={NewDataVendorStream}/>
        <Route path={`${path}/:dataVendorKey/streams/:streamId/edit`} component={EditDataVendorStream}/>
        <Route path={`${path}/:dataVendorKey/streams/:streamId`} component={DataVendorStream}/>
        <Route path={`${path}/:dataVendorKey/extracts/new`} component={NewDataVendorExtract}/>
        <Route path={`${path}/:dataVendorKey/extracts/:extractId/edit`} component={EditDataVendorExtract}/>
        <Route path={`${path}/:dataVendorKey/extracts/:extractId`} component={DataVendorExtract}/>
        <Route path={`${path}/:dataVendorKey/users/new`} component={DataVendorUserNew}/>
        <Route path={`${path}/:dataVendorKey/users/:userId/edit`} component={DataVendorUserEdit}/>
        <Route path={`${path}/:dataVendorKey/users/:userId`} component={DataVendorUser}/>
        <Route path={`${path}/:dataVendorKey/audiences/new`} component={NewDataVendorAudience}/>
        <Route path={`${path}/:dataVendorKey/audiences/:audienceId/edit`} component={EditDataVendorAudience}/>
        <Route path={`${path}/:dataVendorKey/audiences/:audienceId`} component={DataVendorAudience}/>
        <Route path={`${path}/:dataVendorKey/edit`} component={DataVendorsEdit}/>
        <Route path={`${path}/:dataVendorKey/revenues/:year/:month`} component={DataVendorInvoice}/>
        <Route path={`${path}/:dataVendorKey`} component={DataVendor}/>
      </Switch>
    </Suspense>
  )
}

export default DataVendors
